module.exports = __webpack_public_path__ + "src/assets/games/12/207.jpg";